import { type FC } from 'react';

import NewServiceCard from '@/components/NewServiceCard';
import ProgressBarLoader from '@/components/ProgressBarLoader';
import { NOODLE_CREATOR_ID } from '@/configuration/client';
import { isConsultationProduct } from '@/helpers/isProductType';
import { IDENTIFIERS, getUrl } from '@/helpers/urlsHelper';
import { type getCreator } from '@/tsClient';

import type { ThisProduct } from '../CreatorBySlug';

import s from './Services.module.scss';

const Services: FC<{
  isFetching: boolean;
  creator: Awaited<ReturnType<typeof getCreator>>;
  connectProducts: ThisProduct[];
  canEdit: boolean;
}> = ({ isFetching, creator, connectProducts, canEdit }) => (
  <div className={s.chats}>
    {isFetching ? (
      <ProgressBarLoader chunks={[{ label: 'Fetching services data...', loaded: false }]} />
    ) : (
      connectProducts
        .filter(
          (product) =>
            product.isActive &&
            product.showOnOneLink &&
            (product.prices.some((price) => price.isActive) || product.initiateWorkflowCTAs?.length > 0),
        )
        .map((product) => {
          const isConsultation = isConsultationProduct(product);
          const isNoodleConsultation = isConsultation && NOODLE_CREATOR_ID === creator.id;

          let productUrl;
          if (isNoodleConsultation) {
            productUrl = 'https://noodle.law/meet';
          } else if (isConsultation) {
            productUrl = getUrl(IDENTIFIERS.PRODUCT_TYPE, { creatorSlug: creator.slug, productTypeSlug: product.slug });
          } else {
            productUrl = getUrl(IDENTIFIERS.PRODUCT, { creatorSlug: creator.slug, productSlug: product.slug });
          }

          return (
            <NewServiceCard
              key={product.id}
              product={product}
              creator={creator}
              canEdit={canEdit}
              to={productUrl}
              newTab={isNoodleConsultation}
            />
          );
        })
    )}
  </div>
);

export default Services;
